jQuery(document).ready(function($) {
  let currentPage = 1;
  let isLoading = false;
  let currentCategoryId = 0; // 0は全カテゴリ
  const $moreBtn = $('.achievements_more_btn');
  const $achievementsList = $('.achievements_list');
  const $catItems = $('.achievements_cat_item');
  
  if (!$achievementsList.length) {
    return;
  }

  // カテゴリクリックイベント
  $catItems.on('click', function(e) {
    e.preventDefault();
    
    if (isLoading) {
      return;
    }

    const categoryId = $(this).data('category-id');
    const isActive = $(this).hasClass('active');
    
    // アクティブなカテゴリが再度クリックされた場合は、すべてのアクティブを外して全記事を表示
    if (isActive && categoryId === currentCategoryId) {
      isLoading = true;
      currentPage = 1;
      currentCategoryId = 0; // 全カテゴリ
      
      // すべてのアクティブクラスを外す
      $catItems.removeClass('active');
      
      // リストをクリア（アニメーション付き）
      $moreBtn.hide();
      // 高さを維持したままフェードアウト
      $achievementsList.css('min-height', $achievementsList.height());
      $achievementsList.animate({ opacity: 0 }, 300, function() {
        $achievementsList.css('min-height', '');
        // more_btnを一時的に保存（achievements_listの外に移動）
        const $moreBtnClone = $moreBtn.detach();
        $achievementsList.empty();
        
        // フェードアウト完了後にAjaxリクエストを実行
        $.ajax({
          url: ajaxurl,
          type: 'POST',
          data: {
            action: 'load_achievements_posts',
            nonce: achievementsAjaxData.nonce,
            page: currentPage,
            category_id: 0
          },
          success: function(response) {
            if (response.success && response.data.posts_html) {
              // 記事を追加
              $achievementsList.html(response.data.posts_html);
              
              // more_btnを再配置
              $achievementsList.append($moreBtnClone);
              
              // 6件以上ある場合はmore_btnを表示
              if (response.data.has_more) {
                $moreBtn.show();
                $moreBtn.text('more');
                $moreBtn.removeClass('loading');
              } else {
                $moreBtn.hide();
              }
              
              // フェードインアニメーション
              $achievementsList.css('opacity', 0);
              $achievementsList.animate({ opacity: 1 }, 300);
            } else {
              $achievementsList.html('<p>記事が見つかりませんでした。</p>');
              $achievementsList.append($moreBtnClone);
              $moreBtn.hide();
              $achievementsList.css('opacity', 0);
              $achievementsList.animate({ opacity: 1 }, 300);
            }
            isLoading = false;
          },
          error: function() {
            $achievementsList.html('<p>記事の読み込みに失敗しました。</p>');
            $achievementsList.css('opacity', 0);
            $achievementsList.animate({ opacity: 1 }, 300);
            isLoading = false;
          }
        });
      });
      return;
    }

  // 新しいカテゴリがクリックされた場合
  isLoading = true;
  currentPage = 1;
  currentCategoryId = categoryId;
  
  // アクティブクラスの切り替え
  $catItems.removeClass('active');
  $(this).addClass('active');
  
  // リストをクリア（アニメーション付き）
  $moreBtn.hide();
  // 高さを維持したままフェードアウト
  $achievementsList.css('min-height', $achievementsList.height());
  $achievementsList.animate({ opacity: 0 }, 300, function() {
    $achievementsList.css('min-height', '');
    // more_btnを一時的に保存（achievements_listの外に移動）
    const $moreBtnClone = $moreBtn.detach();
    $achievementsList.empty();
    
    // フェードアウト完了後にAjaxリクエストを実行
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        action: 'load_achievements_posts',
        nonce: achievementsAjaxData.nonce,
        page: currentPage,
        category_id: categoryId
      },
      success: function(response) {
        if (response.success && response.data.posts_html) {
          // 記事を追加
          $achievementsList.html(response.data.posts_html);
          
          // more_btnを再配置
          $achievementsList.append($moreBtnClone);
          
          // 6件以上ある場合はmore_btnを表示
          if (response.data.has_more) {
            $moreBtn.show();
            $moreBtn.text('more');
            $moreBtn.removeClass('loading');
          } else {
            $moreBtn.hide();
          }
          
          // フェードインアニメーション
          $achievementsList.css('opacity', 0);
          $achievementsList.animate({ opacity: 1 }, 300);
        } else {
          $achievementsList.html('<p>記事が見つかりませんでした。</p>');
          $achievementsList.append($moreBtnClone);
          $moreBtn.hide();
          $achievementsList.css('opacity', 0);
          $achievementsList.animate({ opacity: 1 }, 300);
        }
        isLoading = false;
      },
      error: function() {
        $achievementsList.html('<p>記事の読み込みに失敗しました。</p>');
        $achievementsList.css('opacity', 0);
        $achievementsList.animate({ opacity: 1 }, 300);
        isLoading = false;
      }
    });
  });
  });

  // 初期表示時、既に表示されている記事数を確認
  const initialPostsCount = $achievementsList.find('.achievements_item').length;
  if (initialPostsCount < 6) {
    $moreBtn.hide();
  }

  // more_btnクリックイベント
  $moreBtn.on('click', function(e) {
    e.preventDefault();
    
    if (isLoading) {
      return;
    }

    isLoading = true;
    currentPage++;
    
    $moreBtn.text('読み込み中...');
    $moreBtn.addClass('loading');

    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        action: 'load_achievements_posts',
        nonce: achievementsAjaxData.nonce,
        page: currentPage,
        category_id: currentCategoryId
      },
      success: function(response) {
        if (response.success && response.data.posts_html) {
          // 追加前の記事数を保存
          const beforeCount = $achievementsList.find('.achievements_item').length;
          
          // 記事を追加（more_btnの前に挿入）
          $moreBtn.before(response.data.posts_html);
          
          // 追加された最初の要素を取得
          const $newItems = $achievementsList.find('.achievements_item');
          const $firstNewItem = $newItems.eq(beforeCount);
          
          // 追加された最初の要素までスクロール
          if ($firstNewItem.length) {
            const offsetTop = $firstNewItem.offset().top;
            const headerHeight = $('#header').outerHeight() || 0;
            const scrollPosition = offsetTop - headerHeight - 20; // ヘッダー分と余白を引く
            
            $('html, body').animate({
              scrollTop: scrollPosition
            }, 500);
          }
          
          // これ以上記事がない場合はボタンを非表示
          if (!response.data.has_more) {
            $moreBtn.hide();
          } else {
            $moreBtn.text('more');
            $moreBtn.removeClass('loading');
          }
        } else {
          $moreBtn.text('more');
          $moreBtn.removeClass('loading');
          alert('記事の読み込みに失敗しました');
        }
        isLoading = false;
      },
      error: function() {
        $moreBtn.text('more');
        $moreBtn.removeClass('loading');
        alert('記事の読み込みに失敗しました');
        isLoading = false;
        currentPage--; // ページ番号を戻す
      }
    });
  });

  // achievements_item_imageクリックでdialogを開く
  $(document).on('click', '.achievements_item_image', function(e) {
    e.preventDefault();
    const dialogId = $(this).data('dialog-id');
    if (dialogId) {
      const $dialog = $('#' + dialogId);
      if ($dialog.length && $dialog[0].showPopover) {
        $dialog[0].showPopover();
      }
    }
  });
});

